export const MAIN_PAGE = "main"
export const PARAMETERS_PAGE = "parameters"
export const ACCOUNT_PAGE = "account"
export const EMAIL_PAGE = "email"
export const PASSWORD_PAGE = "password"